<template>
    <div class="content">
        <div id="roll" v-show="isguangao">
            <img src="/image/guanggao/clos.png" width="16" @click="isshow" class="alignright" />
            <a :href="httphelper.IsDebugGP519() + '/home/inforDetails?id=1294&column_Type=42'" target="_blank">
                <img class="rollimg" src="/image/guanggao/guanggao.png" alt />
            </a>
        </div>
        <div class="bannerWrap">
            <div class="topbanner EC_width display_between">
                <div class="bannerleft">
                    <swiper :options="swiperOption" v-if="homeRotation && homeRotation.length > 0" ref="mySwiper">
                        <swiper-slide v-for="(item, index) in homeRotation" class="swiperbox" :key="index">
                            <img :src="item.resUrl" class="swiperimg" width="930" height="380" @click="Towindowurl(item.url)" />
                            <img src="../../assets/img/medical.png" class="swiperlogo" alt="" />
                        </swiper-slide>
                        <div class="swiper-pagination" slot="pagination" @click="swiperpagination()"></div>
                    </swiper>
                </div>
                <div class="bannerright display_column display_between">
                    <img
                        v-for="(item, index) in topRotation"
                        :key="index + '1'"
                        :src="item.resUrl"
                        @click="Towindowurl(item.url)"
                        width="296"
                        height="183"
                        style="border-radius: 10px; cursor: pointer"
                    />
                    <img
                        v-for="(item, index) in botRotation"
                        :key="index + '2'"
                        :src="item.resUrl"
                        @click="Towindowurl(item.url)"
                        width="296"
                        height="183"
                        style="border-radius: 10px; cursor: pointer; box-shadow: 0px 16px 14px 0px rgba(0, 0, 0, 0.15)"
                    />
                </div>
            </div>
        </div>
        <div class="main display_between_nocenter EC_width">
            <div class="mainLeft">
                <div class="gl_title_bar">
                    <div class="gl_tb_left">
                        <span class="normaltitle">{{ zttj47 }}</span>
                    </div>
                    <div class="gl_tb_right">
                        <a href="javascript:;" class="gl_tb_right_more" @click="onMore(47, zttj47)">
                            <img src="/image/index/moreimg.png" class="gltb_moreimg" />
                            更多
                        </a>
                    </div>
                </div>
                <div class="gl_listWrapBar_noflex" v-for="(item, index) in specirecolist" :key="index" @click="clickSpecial(item)">
                    <div class="gl_listItemTitle gl_ltStyle_line" style="font-family: Microsoft YaHei; color: #0b8586">
                        {{ ellipsis(item.title, 19) }}
                    </div>
                    <div class="gl_imgList marginTop25 marginBottom25">
                        <img :src="item.slideShow" class="specirecolist_img imgtran" />
                    </div>
                    <a href="javascript:;" class="gl_listItem">
                        <div class="gl_listItemTitle fontBold" style="font-family: Microsoft YaHei; color: #404040">
                            {{ ellipsis(item.abstract, 10) }}
                        </div>
                        <div class="display_between marginTop11">
                            <div class="gl_inforshow">
                                <span class="marginRight20">
                                    {{ formatTime(item.publishtime, 'YYYY/MM/DD') }}
                                </span>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
            <div class="mainCenter flex1">
                <div class="gl_title_bar">
                    <div class="gl_tb_left">
                        <span class="tagTitle" :class="{ tagTitleActive: hotTagindex == 0 }" @click="tagDatahot(0)">
                            {{ redian42 }}
                        </span>
                        <span class="tagTitle" :class="{ tagTitleActive: hotTagindex == 1 }" @click="tagDatahot(1)">
                            {{ zhengce43 }}
                        </span>
                    </div>
                    <div class="gl_tb_right">
                        <!-- <a href="javascript:;" class=" redColor marginRight20" @click="refreshData('hot')"><img src="/image/index/xuanzhuan.png" style="vertical-align: -1px;margin-right: 5px;">换一批</a> -->
                        <a href="javascript:;" class="gl_tb_right_more" @click="onMore(hotTagindex == 0 ? 42 : 43, hotTagindex == 0 ? redian42 : zhengce43)">
                            <img src="/image/index/moreimg.png" class="gltb_moreimg" />
                            更多
                        </a>
                    </div>
                </div>
                <!--热点/政策-->
                <div v-for="(item, index) in newlistdata" :key="index + '1'">
                    <div class="gl_listWrapBar_nopad controlShow" style="margin: 5px 0">
                        <div class="gl_imgList setShow" @click="clkNews(item, hotTagindex == 0 ? redian42 : zhengce43)">
                            <img :src="item.slideShow" height="88" width="156" class="imgtran" />
                        </div>
                        <a href="javascript:;" class="gl_listItem display_column">
                            <div class="gl_listItemTitle fontBold setShow" style="margin-bottom: 9px" @click="clkNews(item, hotTagindex == 0 ? redian42 : zhengce43)">
                                {{ item.title }}
                            </div>
                            <div class="gl_listItemTitle disShow" style="margin-bottom: 8.8px" @click="clkNews(item, hotTagindex == 0 ? redian42 : zhengce43)">
                                {{ ellipsis(item.title, 38) }}
                            </div>
                            <div class="display_between marginTop10 setShow">
                                <div>
                                    <span v-bind:class="calculate(index)" v-for="(qitem, index) in (item.labelName || '').split(',')" :key="index" @click="onsearch(qitem)">
                                        {{ qitem }}
                                    </span>
                                </div>
                                <div class="gl_inforshow">
                                    <span class="marginRight20">
                                        {{ formatTime(item.publishtime, 'YYYY/MM/DD') }}
                                    </span>
                                    <span>
                                        <img src="/image/index/chakan.png" />
                                        {{ item.clickVolume }}
                                    </span>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="gl_title_bar marginTop22" style="margin-top: 32px">
                    <div class="gl_tb_left">
                        <span class="tagTitle" :class="{ tagTitleActive: infoTagindex == 0 }" @click="tagDatainfo(0)">
                            {{ hwzx44 }}
                        </span>
                        <span class="tagTitle" :class="{ tagTitleActive: infoTagindex == 1 }" @click="tagDatainfo(1)">
                            {{ tssk45 }}
                        </span>
                    </div>
                    <div class="gl_tb_right">
                        <!-- <a href="javascript:;" class=" redColor marginRight20" @click="refreshData('consult')"><img src="/image/index/xuanzhuan.png" style="vertical-align: -1px;margin-right: 2px;">换一批</a> -->
                        <a href="javascript:;" class="gl_tb_right_more" @click="onMore(infoTagindex == 0 ? 44 : 45, infoTagindex == 0 ? hwzx44 : tssk45)">
                            <img src="/image/index/moreimg.png" class="gltb_moreimg" />
                            更多
                        </a>
                    </div>
                </div>
                <div class="gl_listWrapBar" v-for="(item, index) in consultListdata.slice(0, 6)" :key="index + 1">
                    <div class="gl_imgList" @click="clkNews(item, infoTagindex == 0 ? hwzx44 : tssk45)">
                        <img :src="item.slideShow" width="156" height="88" />
                    </div>
                    <a href="javascript:;" class="gl_listItem display_column display_between_nocenter">
                        <div class="gl_listItemTitle" @click="clkNews(item, infoTagindex == 0 ? hwzx44 : tssk45)">
                            {{ ellipsis(item.title, 25) }}
                        </div>
                        <div class="gl_listItemSub" @click="clkNews(item, infoTagindex == 0 ? hwzx44 : tssk45)">
                            {{ ellipsis(item.abstract, 25) }}
                        </div>
                        <div class="display_between marginTop5 marginBottom4">
                            <div>
                                <span v-bind:class="calculate(index)" v-for="(qitem, index) in (item.labelName || '').split(',')" :key="index" @click="onsearch(qitem)">
                                    {{ qitem }}
                                </span>
                            </div>
                            <div class="gl_inforshow">
                                <span class="marginRight20">
                                    {{ formatTime(item.publishtime, 'YYYY/MM/DD') }}
                                </span>
                                <span>
                                    <img src="/image/index/chakan.png" class="marginRight5" />
                                    {{ item.clickVolume }}
                                </span>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
            <div class="mainRight">
                <div v-for="(item, index) in rightvideoList" :key="index + 1">
                    <div class="gl_title_bar">
                        <div class="gl_tb_left">
                            <span class="normaltitle">
                                {{ item.title }}
                            </span>
                        </div>
                        <div class="gl_tb_right">
                            <!-- <a href="javascript:;" class="gl_tb_right_more"><img src="/image/index/moreimg.png" class="gltb_moreimg">更多</a> -->
                        </div>
                    </div>
                    <div v-for="(vitem, vindex) in videoList.filter(vitem => vitem.cid == item.id)" :key="vindex">
                        <!-- :class="{ borderlast: index == rightvideoList.length - 1 }" -->
                        <div class="video_block marginTop23" style="padding-bottom: 0px">
                            <div style="width: 300px; height: 169px">
                                <video
                                    @contextmenu.prevent=""
                                    v-if="vitem.contents != ''"
                                    v-bind:src="vitem.contents"
                                    class="cont_img"
                                    controls="controls"
                                    controlslist="nodownload"
                                    type="video/mp4"
                                    :ref="'video' + index"
                                >
                                    您的浏览器不支持视频播放
                                </video>
                            </div>
                            <div class="video_title">
                                <span v-if="vitem.abstract != ''">
                                    {{ vitem.abstract }}
                                </span>
                                <span v-else>{{ vitem.title }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="text_center" v-for="(item, index) in centreRotation" :key="index" @click="Towindowurl(item.url)">
            <img :src="item.resUrl" class="imgtran" width="1200px" />
        </div>
        <div class="main EC_width display_between_nocenter">
            <div class="mainLeft">
                <div class="tip_panel" style="margin-bottom: 9px"></div>
                <div class="gl_listWrapBar_noflex" style="padding: 21px 0" v-for="(item, index) in lowerRotation" :key="index" @click="Towindowurl(item.url)">
                    <a href="javascript:;" class="gl_listItem">
                        <div class="gl_listItemTitle gl_ltStyle_line fontBold" style="color: #1d7f88">
                            {{ item.title }}
                        </div>
                    </a>
                </div>
            </div>
            <div class="mainCenter flex1">
                <div class="gl_title_bar">
                    <div class="gl_tb_left">
                        <span class="normaltitle">{{ qkbl48 }}</span>
                    </div>
                    <div class="gl_tb_right">
                        <a href="javascript:;" class="gl_tb_right_more" @click="onMore(48, qkbl48)">
                            <img src="/image/index/moreimg.png" class="gltb_moreimg" />
                            更多
                        </a>
                    </div>
                </div>
                <div class="gl_listWrapBar" v-for="(item, index) in gencaselist" :key="index + 1">
                    <div class="gl_imgList" v-if="item.slideShow != ''">
                        <img :src="item.slideShow" width="156px" height="88px;" @click="clkNews(item, qkbl48)" />
                    </div>
                    <a href="javascript:;" class="gl_listItem display_column display_between_nocenter">
                        <div class="gl_listItemTitle" @click="clkNews(item, qkbl48)" style="font-size: 18px">
                            {{ ellipsis(item.title, 25) }}
                        </div>
                        <div class="gl_listItemSub" @click="clkNews(item, qkbl48)">
                            {{ ellipsis(item.abstract, 25) }}
                        </div>
                        <div class="display_between marginTop10 marginBottom4">
                            <div v-if="item.labelName != ''" style="flex: 1">
                                <span v-bind:class="calculate(index)" v-for="(qitem, index) in (item.labelName.replace(/；/g, ',') || '').split(',').slice(0, 3)" :key="index" @click="onsearch(qitem)">
                                    {{ qitem }}
                                </span>
                                <!--<span class="gl_red_block">诊断</span>-->
                                <!--<span class="gl_blue_block">诊断管理</span>-->
                            </div>
                            <div v-else></div>
                            <div class="gl_inforshow">
                                <span class="marginRight20">
                                    {{ formatTime(item.publishtime, 'YYYY/MM/DD') }}
                                </span>
                                <span>
                                    <img src="/image/index/chakan.png" class="marginRight5" />
                                    {{ item.clickVolume }}
                                </span>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
            <div class="mainRight">
                <div class="gl_title_bar">
                    <div class="gl_tb_left">
                        <span class="normaltitle">热门内容</span>
                    </div>
                </div>
                <ul class="ulList_block">
                    <li v-for="(item, index) in popularList" :key="index + 1" @click="onsearch(item.labelName)">
                        <a href="javascript:;">{{ item.labelName }}</a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="chaxun">
            <el-dialog title="投稿查询" :visible.sync="dialogTableVisible" style="margin-top: 10%">
                <el-button type="success" plain @click="tougao('http://qkhy.bosihw.cn/Admin/user/login/')">2022年海医会年会投稿查询</el-button>
                <el-button type="primary" plain @click="tougao('http://zgqkyxauthor.manuscriptcloud.com/login')">《中国全科医学》杂志投稿查询</el-button>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import format from '@/assets/unit/unit.js';
// import func from 'vue-editor-bridge'
export default {
    name: 'home',
    data() {
        return {
            showmodal: false,
            apiData: {
                bannerImgList: {},
                specialList: {},
                hotPolicy: {},
                consultList: {},
                videoList: {},
                qkcase: {},
                hotContent: {},
            },
            // 热点切换index
            hotTagindex: 0,
            // 海外咨询切换index
            infoTagindex: 0,
            swiperOption: {
                loop: true,
                // 显示分页
                pagination: {
                    el: '.swiper-pagination',
                    bulletClass: 'bulletWrite',
                    bulletActiveClass: 'bulletWriteActive',
                    clickable: true,
                },
                autoplay: {
                    delay: 15000,
                    disableOnInteraction: false,
                },
            },
            /**田连培 */
            specirecolist: [], //首页专题
            gencaselist: [], //首页全科病例
            videoList: [], //精彩视听
            columntopList: [], //栏目名称
            newlist: [], //新闻列表
            newlistdata: [],
            consultListdata: [],
            homeRotation: null, //首页轮播
            topRotation: null, //首页右上
            botRotation: null, //首页右下
            centreRotation: null, //首页中
            lowerRotation: null, //首页下
            popularList: null, //热门内容,
            colorList: ['gl_gree_block', 'gl_red_block', 'gl_blue_block'],
            rightvideoList: [
                {
                    title: '每周医课',
                    id: 80,
                },
                {
                    title: '每周技能',
                    id: 81,
                },
                {
                    title: '基层评点',
                    id: 46,
                },
                {
                    title: '指南解读',
                    id: 191,
                },
                {
                    title: '科研课程',
                    id: 194,
                },
            ],
            redian42: '',
            zhengce43: '',
            hwzx44: '',
            tssk45: '',
            zttj47: '',
            qkbl48: '',
            isguangao: false,
            dialogTableVisible: false,
        };
    },
    created() {
        // this.getData()
        this.getSpecilCaseList();
        this.GetColumsInfoAllList();
        this.GetRotationInfo();
        this.GetPopularContent();
        this.wechatcallback();
    },

    methods: {
        tougao(url) {
            this.dialogTableVisible = false;
            window.open(url);
        },
        getDuration() {
            if (this.jishu == 0) {
                this.videoname = this.videolist[0].res_Title;
            }
            let time = this.$refs.video.duration; //获取视频的总时长
            const hour = parseInt(time / 3600) < 10 ? '0' + parseInt(time / 3600) : parseInt(time / 3600);
            const min = parseInt((time % 3600) / 60) < 10 ? '0' + parseInt((time % 3600) / 60) : parseInt((time % 3600) / 60);
            const sec = parseInt((time % 3600) % 60) < 10 ? '0' + parseInt((time % 3600) % 60) : parseInt((time % 3600) % 60);
            if (hour > 0) {
                this.videoTime = hour + ':' + min + ':' + sec;
            } else {
                this.videoTime = min + ':' + sec;
            }
        },
        calculate(index) {
            var nm = this.colorList[Math.floor(index % 3)];
            return nm;
        },
        refreshData(msg) {
            // hot为热点政策数据consult为海外咨询数据，可根据切换的（hotTagindex:0,infoTagindex:0,）0或1判断是刷新的哪个数据
            if (msg == 'hot') {
                this.apiData.hotPolicy.data = [];
            } else if (msg == 'consult') {
                this.apiData.consultList.data = [];
            }
        },
        tagDatahot(index) {
            // 热点政策数据
            this.hotTagindex = index;
            this.newlistdata = [];
            if (index == 0) {
                this.newlistdata = this.newlist.filter(function (item) {
                    return item.cid == 42;
                });
            } else if (index == 1) {
                this.newlistdata = this.newlist.filter(function (item) {
                    return item.cid == 43;
                });
            }
        },
        tagDatainfo(index) {
            // 海外咨询/实话实说数据
            this.infoTagindex = index;
            // 0海外咨询1为实话实说
            if (index == 0) {
                this.consultListdata = [];
                this.consultListdata = this.newlist.filter(function (item) {
                    return item.cid == 44;
                });
            } else if (index == 1) {
                this.consultListdata = [];
                this.consultListdata = this.newlist.filter(function (item) {
                    return item.cid == 45;
                });
            }
        },
        /**tianlianpei */
        /** 获取首页专题，全科病例数据*/
        //获取首页专题，全科病例数据
        getSpecilCaseList() {
            let _this = this;
            let arr = [46, 47, 48, 80, 81, 191, 194];
            for (let i = 0; i < arr.length; i++) {
                _this.httphelper
                    .post('/api/NewApi/GetGpSiteNewInfoPageList', {
                        keyword: '',
                        id: 0,
                        parentID: 0,
                        column_Type: arr[i],
                        pageIndex: 0,
                        pageSize: arr[i] == 46 ? 4 : arr[i] == 47 || arr[i] == 48 ? 6 : 4,
                    })
                    .then(res => {
                        if (res.data.code == 200) {
                            if (res.data.data.gpSiteNewInfoViewsViews != null && res.data.data.gpSiteNewInfoViewsViews.length > 0) {
                                res.data.data.gpSiteNewInfoViewsViews.forEach(item => {
                                    if (item.cid == 46 || item.cid == 80 || item.cid == 81 || item.cid == 191 || item.cid == 194) {
                                        let contents = item.contents;
                                        item.contents = _this.getVideoSrc(contents);
                                        // console.log(item.content)
                                        // item.contents = contents
                                        //     .replace('" style="width:800px;height:450px;margin:0px 5%;outline:none;" controlslist="nodownload">您的浏览器不支持视频播放</video>', '')
                                        //     .replace('<video src="', '');
                                        // item.contents = item.contents
                                        //     .replace(
                                        //         '" style="width:800px;height:450px;margin:0px 5%;outline:none;" controlslist="nodownload" controls="controls">您的浏览器不支持视频播放</video>',
                                        //         ''
                                        //     )
                                        //     .replace(/<[^>]+>/g, '');
                                        _this.videoList.push(item);
                                        // console.log(_this.videoList);
                                        _this.videoList.sort(function (a, b) {
                                            return a.id - b.id;
                                        });
                                    }
                                    if (item.cid == 47) {
                                        _this.specirecolist.push(item);
                                    }
                                    if (item.cid == 48) {
                                        //全科病例
                                        _this.gencaselist.push(item);
                                    }
                                });
                            }
                        }
                    });
            }
        },
        getVideoSrc(htmlStr) {
            const srcMatch = htmlStr.match(/src="([^"]+)"/);
            // console.log(srcMatch ? srcMatch[1] : '')
            return srcMatch ? srcMatch[1] : '';
        },
        /**获取栏目数据 */
        GetColumsInfoAllList() {
            let _this = this;
            _this.httphelper
                .post('/api/NewApi/GetColumsInfoAllList', {
                    cType: 1,
                    isCHorEN: 1,
                })
                .then(res => {
                    if (res.data.code == 200) {
                        let data = res.data.data.sort(function (a, b) {
                            return a.sort - b.sort;
                        });
                        data.forEach(item => {
                            if (item.parentid == '32') {
                                //首页
                                if (item.id == 42 || item.id == 43 || item.id == 44 || item.id == 45) {
                                    _this.columntopList.push(item);
                                }
                                switch (item.id) {
                                    case 42:
                                        _this.redian42 = item.name;
                                        break;
                                    case 43:
                                        _this.zhengce43 = item.name;
                                        break;
                                    case 44:
                                        _this.hwzx44 = item.name;
                                        break;
                                    case 45:
                                        _this.tssk45 = item.name;
                                        break;
                                    case 46:
                                        _this.rightvideoList[2].title = item.name;
                                        break;
                                    case 47:
                                        _this.zttj47 = item.name;
                                        break;
                                    case 48:
                                        _this.qkbl48 = item.name;
                                        break;
                                    case 80:
                                        _this.rightvideoList[0].title = item.name;
                                        break;
                                    case 81:
                                        _this.rightvideoList[1].title = item.name;
                                        break;
                                    case 191:
                                        _this.rightvideoList[3].title = item.name;
                                        break;
                                    case 194:
                                        _this.rightvideoList[4].title = item.name;
                                        break;
                                }
                            }
                        });
                        //获取首页热门内容数据
                        _this.GetGpSiteNewInfoPageList();
                    }
                });
        },
        /**获取首页中部新闻信息 */
        GetGpSiteNewInfoPageList() {
            let _this = this;
            let arrcolumntop = _this.columntopList;
            for (let i = 0; i < arrcolumntop.length; i++) {
                _this.httphelper
                    .post('/api/NewApi/GetGpSiteNewInfoPageList', {
                        keyword: '',
                        id: 0,
                        parentID: 0,
                        column_Type: arrcolumntop[i].id,
                        pageIndex: 0,
                        pageSize: 12,
                    })
                    .then(res => {
                        if (res.data.code == 200) {
                            if (res.data.data.gpSiteNewInfoViewsViews != null && res.data.data.gpSiteNewInfoViewsViews.length > 0) {
                                res.data.data.gpSiteNewInfoViewsViews.forEach(item => {
                                    _this.newlist.push(item);
                                });
                            }
                            _this.newlistdata = _this.newlist.filter(item => item.cid == 42);
                            _this.consultListdata = _this.newlist.filter(item => item.cid == 44);
                        }
                    });
            }
        },
        /** 获取轮播数据*/
        GetRotationInfo() {
            let _this = this;
            let arr = [1, 2, 3, 4, 5]; //分别代表首页轮播，首页右上，首页右下，首页中部，首页下部
            for (let i = 0; i < arr.length; i++) {
                _this.httphelper
                    .post('/api/WebSetMessApi/GetRotationInfo', {
                        type: arr[i],
                        ruselocation: 1,
                        source: 2,
                    })
                    .then(res => {
                        if (res.data.code == 200) {
                            if (arr[i] == 1) {
                                _this.homeRotation = res.data.data || null;
                            }
                            if (arr[i] == 2) {
                                _this.topRotation = res.data.data || null;
                            }
                            if (arr[i] == 3) {
                                _this.botRotation = res.data.data || null;
                            }
                            if (arr[i] == 4) {
                                _this.centreRotation = res.data.data || null;
                            }
                            if (arr[i] == 5) {
                                _this.lowerRotation = res.data.data || null;
                            }
                        }
                    });
            }
        },
        /** 轮播、广告图跳转外链
轮播、广告图跳转外链 */
        Towindowurl(url, tougao) {
            let urlstr = url;
            let param = urlstr.substr(urlstr.indexOf('?'), urlstr.length - urlstr.indexOf('?'));
            if (urlstr.search('grasshealList/grasshealListdetail') > -1) {
                const { href } = this.$router.resolve({
                    path: '/home/inforDetails?' + param,
                });
                window.open(href, '_blank');
            } else if (url != null && url != '') {
                if (tougao == true) {
                    this.dialogTableVisible = true;
                } else {
                    window.open(url);
                }
            }
        },
        /**获取首页热门内容*/
        GetPopularContent() {
            let _this = this;
            _this.httphelper.get('/api/NewApi/GetPopularContent').then(res => {
                if (res.code == 200) {
                    _this.popularList = res.data;
                }
            });
        },
        formatTime(datatime, timeformat) {
            return format(datatime, timeformat);
        },

        /**更多 */
        onMore(cid, conetntitle) {
            this.$router.push({
                path: '/home/Inforlist',
                query: {
                    pid: 32,
                    title: conetntitle,
                    cid: cid,
                },
            });
        },

        /**新闻的点击事件 */
        clkNews(info, meuntitle) {
            //如果外连接存在，跳转外链，否则跳转详情
            if (Object.keys(info.address).length == 0) {
                var param = {
                    pid: 32,
                    title: meuntitle,
                    cid: info.cid,
                    goroutename: 'home/Inforlist',
                };
                localStorage.setItem('Inforlist_param_' + info.cid, JSON.stringify(param));
                const { href } = this.$router.resolve({
                    path: '/home/Inforlist/inforDetails?',
                    query: {
                        id: info.id,
                        column_Type: info.cid,
                    },
                });
                window.open(href, '_blank');
            } else {
                window.open(info.address);
            }
        },
        clickSpecial(info) {
            let urlstr = info.address;
            let param = urlstr.substr(urlstr.indexOf('?'), urlstr.length - urlstr.indexOf('?'));
            if (urlstr.search('specialRecomme') > -1) {
                const { href } = this.$router.resolve({
                    path: '/home/specialRecomme' + param,
                });
                window.open(href, '_blank');
            } else if (urlstr.search('specialproject') > -1) {
                const { href } = this.$router.resolve({
                    path: '/enterprise/qyhome' + param,
                });
                window.open(href, '_blank');
            } else {
                window.open(info.address, '_blank');
            }
        },
        onsearch(keywords) {
            const { href } = this.$router.resolve({
                path: '/home/searchPage?',
                query: {
                    labelname: keywords,
                },
            });
            window.open(href, '_blank');
        },
        wechatcallback() {
            var url = location.search;
            var theRequest = new Object();
            if (url.indexOf('?') != -1) {
                var str = url.substr(1);
                var strs = str.split('&');
                for (var i = 0; i < strs.length; i++) {
                    theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1]);
                }
                localStorage.setItem('code', theRequest.code);

                if (theRequest.code) {
                    this.httphelper
                        .post('/api/CGpUserApi/WeChatUserLogin', {
                            code: theRequest.code,
                            id: 0,
                        })
                        .then(res => {
                            if (res.data.code == 200) {
                                localStorage.setItem('nickname', res.data.data.nickname);
                                var aData = new Date();
                                var CurrentDategetTime = 0;
                                var VipEdDategetTime = 0;
                                if (res.data.data.memberDate.m_EndDate) {
                                    var CurrentDate =
                                        aData.getFullYear() + '-' + (aData.getMonth() + 1) + '-' + aData.getDate() + ' ' + aData.getHours() + ':' + aData.getMinutes() + ':' + aData.getSeconds();
                                    var VipEdDate = res.data.data.memberDate.m_EndDate;

                                    CurrentDategetTime = new Date(CurrentDate.replace(/-/g, '/')).getTime() / 1000;
                                    VipEdDategetTime = new Date(VipEdDate.replace(/-/g, '/')).getTime() / 1000;
                                }
                                if (res.data.data.memberDate.m_EndDate == null || parseInt(CurrentDategetTime) - parseInt(VipEdDategetTime) >= 0) {
                                    this.userType = 0;
                                } else {
                                    if (res.data.data.memberDate.m_Type == 1) {
                                        this.userType = 1;
                                    } else if (res.data.data.memberDate.m_Type == 2) {
                                        this.userType = 2;
                                    } else {
                                        this.userType = 0;
                                    }
                                }
                                localStorage.setItem('userType', this.userType);
                                this.ResData = JSON.stringify(res.data.data);
                                localStorage.setItem('ResData', this.ResData);

                                setTimeout(() => {
                                    window.location = this.httphelper.IsDebugGP519();
                                }, 1000);
                            } else if (res.data.code == 235) {
                                this.$confirm('此微信未绑定账号，请先账号密码登录在个人中心绑定账号后使用微信扫码登录', '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'warning',
                                }).then(() => {
                                    setTimeout(() => {
                                        window.location = this.httphelper.IsDebugGP519();
                                    }, 1000);
                                });
                            }
                        });
                    // .catch((err) => {})
                } else {
                    return false;
                }
            }
        },
        isshow() {
            this.isguangao = false;
        },
    },
};
</script>

<style scoped>
.content {
    flex: 1;
}

.bannerWrap {
    height: 450px;
    padding-top: 40px;
    box-sizing: border-box;
    background: linear-gradient(180deg, #dbeded, #ffffff);
    min-width: 1240px;
}

/* 上部banner */

.topbanner {
    height: 380px;
}

.bannerleft {
    width: 930px;
    height: 380px;
    background: #005660;
    box-shadow: 0px 16px 14px 0px rgba(0, 0, 0, 0.15);
    border-radius: 20px 20px 20px 20px;
}

.swiperbox {
    position: relative;
}

.swiperimg {
    border-radius: 20px 20px 20px 20px;
    cursor: pointer;
}

.swiperlogo {
    position: absolute;
    top: 0;
    left: 0;
    width: 259px;
    border-radius: 20px 0 0 0;
}

.bannerright {
    width: 299px;
    height: 380px;
    /*box-shadow: 0px 16px 14px 0px rgba(0, 0, 0, 0.15);*/
    border-radius: 0px 0px 20px 0px;
    background: transparent;
}

.main {
    padding: 50px 0;
}

.mainCenter {
    margin: 0 50px;
}

.mainLeft {
    width: 200px;
}

.mainRight {
    width: 300px;
}

.newsList a {
    font-size: 18px;
}

.newsList p {
    line-height: 38px;
}

.tip_panel {
    height: 304px;
    background: url(/image/index/indexbg1.jpg) no-repeat;
    background-size: 100% 100%;
}

.swiper-pagination {
    text-align: left;
    box-sizing: border-box;
    padding-left: 20px;
}

/**tianlianpei */
.cont_img {
    width: 300px;
    height: 169px;
    overflow: hidden;
}

.specirecolist_img {
    width: 200px;
    height: 50px;
}

.imgtran {
    transform: scale(1.03);
    /* transition: all 0.5s ease-out; */
    /* -moz-transition: all 0.5s ease-out;
    -webkit-transition: all 0.5s ease-out;
    -o-transition: all 0.5s ease-out; */
    cursor: pointer;
}

/* .imgtran:hover {
    transform: scale(1.05);
} */
.setShow {
    display: none;
}

.controlShow:hover .setShow {
    display: flex;
}

.controlShow:hover .disShow {
    display: none;
}

#roll {
    margin-top: 1%;
    height: 88px;
    width: 400px;
    position: fixed;
    /*fixed实现绝对定位*/
    cursor: pointer;
    left: 2%;
    /* right: 1%; */
    /* margin-right: 50px; */
    z-index: 9999;
}

.rollimg {
    /* height: 88px; */
    width: 400px;
}

.borderlast {
    border-bottom: 1px solid #ddd;
}

/* 居右  */
.alignright {
    /* display: inline;
    float: right; */
    width: 20px;
    height: 20px;
    position: absolute;
    top: 10%;
    left: 100%;
    margin-top: -25px;
    /* margin-left: -25px; */
}

.video_title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 15px;
}

.chaxun ::v-deep .el-dialog {
    width: 503px;
}
</style>
